
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import TestimonialKeyword from './TestimonialKeyword';
import FAQKeyword from './FAQKeyword';

function Punetomumbaiinternatinalairport() {



    const cardData =
    {
        keyword: 'Pune to Mumbai International Airport Cab Service',
        heading: 'Vedant Travels: Pune to Mumbai International Airport Cab Service',
        headingDescription: 'Vedant Travels offers a reliable and comfortable cab service from Pune to Mumbai International Airport, ensuring a hassle-free travel experience. Whether you are traveling for an international flight, business trip, or leisure, our fleet of well-maintained sedans, SUVs, and luxury cars caters to all travel needs. Our professional drivers ensure a safe and smooth journey, and we provide flexible pickup and drop-off options. With 24/7 availability, affordable fares, and an easy online booking system, Vedant Travels makes your Pune to Mumbai International Airport travel convenient and stress-free.',

        top: 'Top Places to Visit in Mumbai with Vedant Travels',

    "topPlaces": [
    {
        "title": "Gateway of India",
        "description": "One of Mumbai’s most iconic landmarks, the Gateway of India was built in 1924 and overlooks the Arabian Sea. It is a must-visit historical site and a popular tourist attraction."
    },
    {
        "title": "Marine Drive",
        "description": "Also known as the Queen’s Necklace, Marine Drive is a beautiful coastal boulevard perfect for a scenic drive, evening strolls, and enjoying the Mumbai skyline."
    },
    {
        "title": "Elephanta Caves",
        "description": "A UNESCO World Heritage Site, these rock-cut caves are located on Elephanta Island and feature stunning sculptures of Lord Shiva dating back to the 5th century."
    },
    {
        "title": "Chhatrapati Shivaji Maharaj Terminus (CSMT)",
        "description": "A masterpiece of Victorian Gothic architecture, CSMT is a UNESCO-listed railway station and an important landmark in Mumbai."
    },
    {
        "title": "Siddhivinayak Temple",
        "description": "One of the most revered temples in Mumbai, Siddhivinayak Temple is dedicated to Lord Ganesha and attracts thousands of devotees daily."
    },
    {
        "title": "Juhu Beach",
        "description": "A famous beach in Mumbai, Juhu Beach is perfect for enjoying street food, evening walks, and stunning sunset views over the Arabian Sea."
    },
    {
        "title": "Bandra-Worli Sea Link",
        "description": "This modern engineering marvel connects Bandra and Worli and offers breathtaking views of the city skyline and the sea."
    },
    {
        "title": "Colaba Causeway",
        "description": "A paradise for shoppers, Colaba Causeway is known for its vibrant street shopping, boutiques, cafés, and historic buildings."
    },
    {
        "title": "Haji Ali Dargah",
        "description": "Located on an islet in the Arabian Sea, Haji Ali Dargah is a spiritual and architectural marvel visited by people of all faiths."
    },
    {
        "title": "Film City",
        "description": "The heart of Bollywood, Film City offers guided tours showcasing movie sets, film studios, and a glimpse into the world of Indian cinema."
    }
],


services: [
    {
        "name": "Pune to Mumbai Airport Cab Services by Vedant Travels",
        "description": "Traveling from Pune to Mumbai Airport? Book your ride with Vedant Travels for a comfortable, reliable, and hassle-free journey to Chhatrapati Shivaji International Airport or any other terminal. Whether you're catching a flight or arriving after your trip, we provide top-quality, well-maintained vehicles to ensure your travel experience is seamless."
    },
    {
        "name": "Pune to Chhatrapati Shivaji International Airport Cab",
        "description": "Need a ride to Chhatrapati Shivaji International Airport? Choose Vedant Travels for a timely, comfortable, and affordable journey from Pune. Our experienced drivers know the best routes to get you there on time."
    },
    {
        "name": "Pune to Mumbai Domestic Airport Cab",
        "description": "If you are flying from Mumbai's Domestic Airport, Vedant Travels offers convenient and reliable cab services to get you there smoothly. Whether you're traveling for business or leisure, we ensure you reach your destination comfortably."
    },
    {
        "name": "Pune to Chhatrapati Shivaji International Airport",
        "description": "Vedant Travels offers dependable and hassle-free cab services from Pune to Chhatrapati Shivaji International Airport. Our fleet includes a variety of vehicles to suit your needs, ensuring you arrive at the airport stress-free."
    },
    {
        "name": "Pune to Mumbai International Airport Innova Crysta Taxi",
        "description": "Traveling to Mumbai International Airport? Book an Innova Crysta taxi with Vedant Travels for a luxurious and spacious ride. Perfect for those who prefer extra comfort and space during their journey."
    },
    {
        "name": "Pune to Mumbai International Airport Drop",
        "description": "For a smooth and reliable drop-off at Mumbai International Airport, choose Vedant Travels. Our professional drivers ensure you arrive on time and in comfort."
    },
    {
        "name": "Pune to Mumbai International Airport One-Way Cab",
        "description": "If you need a one-way cab from Pune to Mumbai International Airport, Vedant Travels offers affordable and reliable services. No matter the time or day, we’ll ensure you reach the airport comfortably."
    },
    {
        "name": "Pune to Mumbai International Airport Ertiga Cab",
        "description": "For a comfortable, spacious ride to Mumbai International Airport, choose an Ertiga cab with Vedant Travels. The Ertiga is perfect for families or small groups who need more space for a relaxed journey."
    },
    {
        "name": "Pune to Mumbai Ertiga Cab",
        "description": "The Ertiga is a great choice for traveling from Pune to Mumbai, whether you’re going to the airport or another destination. It offers a comfortable ride with plenty of space for your luggage and passengers."
    },
    {
        "name": "Pune to Mumbai Innova Cab",
        "description": "For a premium ride, book an Innova cab with Vedant Travels for your trip from Pune to Mumbai International Airport. Whether you're traveling solo or in a group, the Innova offers a comfortable, spacious, and reliable ride."
    },
    {
        "name": "Pune to Chhatrapati Shivaji International Airport Taxi",
        "description": "Choose Vedant Travels for a convenient and reliable taxi service to Chhatrapati Shivaji International Airport. Our professional drivers ensure a timely and safe ride to the airport."
    },
    {
        "name": "Pune to Mumbai International Airport Innova Crysta Taxi",
        "description": "Book an Innova Crysta for a luxury experience on your way to Mumbai International Airport. The Innova Crysta offers extra comfort and space, making it ideal for long journeys and groups."
    },
    {
        "name": "Pune to Mumbai International Airport Drop",
        "description": "Let Vedant Travels handle your airport drop-off from Pune to Mumbai International Airport. We ensure a punctual and comfortable ride, so you can focus on your flight while we take care of the journey."
    },
    {
        "name": "Pune to Mumbai International Airport Drop Taxi",
        "description": "For a reliable drop taxi service to Mumbai International Airport, choose Vedant Travels. We provide timely and comfortable service, ensuring you reach your destination stress-free."
    },
    {
        "name": "Pune to Mumbai International Airport Vedant Travels",
        "description": "For a comfortable and affordable journey from Pune to Mumbai International Airport, Vedant Travels is your trusted choice. We ensure a smooth, on-time arrival, whether you're flying from Terminal 1 or Terminal 2."
    },
    {
        "name": "Pune to Mumbai International Airport Ertiga Cabs",
        "description": "Travel in comfort with an Ertiga cab from Vedant Travels for your trip to Mumbai International Airport. The spacious vehicle is perfect for families or small groups who need additional space."
    },
    {
        "name": "Pune to Mumbai International Airport Sedan Cabs",
        "description": "Looking for a sedan for your airport ride? Vedant Travels offers comfortable and affordable sedan cabs from Pune to Mumbai International Airport. Ideal for those traveling solo or with a small group, sedan cabs provide a smooth and easy ride."
    },
    {
        "name": "Pune to Mumbai International Airport Swift Dzire Car",
        "description": "Choose a Swift Dzire for a budget-friendly and comfortable ride from Pune to Mumbai International Airport. The sedan offers excellent value while ensuring comfort during your journey."
    },
    {
        "name": "Pune to Mumbai International Airport One-Way Cab",
        "description": "Book a one-way cab with Vedant Travels for a stress-free ride from Pune to Mumbai International Airport. We offer transparent pricing and reliable services to ensure your travel experience is smooth and easy."
    },
    {
        "name": "Pune to Mumbai Airport Contact Information",
        "description": "Contact Vedant Travels at +91 8767459909 for prompt and efficient Pune to Mumbai Airport cab services. Whether you’re heading to Chhatrapati Shivaji International Airport, Domestic Airport, or any terminal, we ensure a smooth and enjoyable ride. Book your Pune to Mumbai Airport cab today!"
    }
],


tableData: [
    ["Pune to Mumbai airport", "-Pune to Chhatrapati Shivaji International Airport cab"],
    ["Pune to Mumbai domestic airport cab", "-Pune to Chhatrapati Shivaji International Airport"],
    ["Pune to Mumbai international airport Innova Crysta taxi", "-Pune to Mumbai international airport drop"],
    ["Pune to Mumbai international airport one way cab", "-Pune to Mumbai international airport Ertiga cab"],
    ["Pune to Mumbai Ertiga cab", ""]
],

whychoose: [
    {
        "WhyChooseheading": "Reliable and On-Time Service",
        "WhyChoosedescription": "At Vedant Travels, we understand that timely arrivals at Mumbai International Airport are crucial for your flight. Our drivers ensure punctual pickups and drop-offs, so you can relax knowing you’ll reach the airport on time for your international flight."
    },
    {
        "WhyChooseheading": "Comfortable and Spacious Vehicles",
        "WhyChoosedescription": "Travel comfortably with our well-maintained, spacious vehicles. Equipped with air conditioning and comfortable seating, our vehicles provide a smooth and relaxing ride, allowing you to rest before your journey."
    },
    {
        "WhyChooseheading": "Experienced and Professional Drivers",
        "WhyChoosedescription": "Our drivers are experienced in handling airport transfers, particularly long-distance routes like Pune to Mumbai International Airport. They are skilled at navigating the best routes, ensuring a safe, efficient, and timely trip."
    },
    {
        "WhyChooseheading": "Affordable and Transparent Pricing",
        "WhyChoosedescription": "Vedant Travels offers competitive rates for Pune to Mumbai International Airport transfers with no hidden charges. Our transparent pricing ensures you know exactly what you’re paying for, with no surprises along the way."
    },
    {
        "WhyChooseheading": "Safe and Comfortable Journey",
        "WhyChoosedescription": "Your safety is our top priority. Our vehicles are regularly serviced and equipped with modern safety features, such as airbags, seat belts, and GPS tracking. Our professional drivers follow strict safety protocols, making your journey secure and comfortable."
    },
    {
        "WhyChooseheading": "24/7 Availability",
        "WhyChoosedescription": "Whether you have an early morning flight or a late-night arrival, Vedant Travels is available 24/7 for your airport transfer needs. Our round-the-clock service ensures you never miss your flight."
    },
    {
        "WhyChooseheading": "Hassle-Free Booking Process",
        "WhyChoosedescription": "Booking a cab for your Pune to Mumbai International Airport transfer is simple. You can book online via our website or mobile app, or call our customer service team to assist you with the booking process."
    },
    {
        "WhyChooseheading": "Customized Travel Packages",
        "WhyChoosedescription": "We offer flexible packages for your airport transfer needs. Whether you're traveling alone, with family, or for business, we can tailor the service to fit your preferences and travel schedule."
    }
]







    }


    const faqData = [
        {
            id: 1,
            question: 'How can I book a Pune to Mumbai International Airport cab with Vedant Travels?',
            answer: 'You can easily book your cab online through our website or mobile app. Alternatively, you can contact our customer service team for assistance with booking.',
        },
        {
            id: 2,
            question: 'Are the drivers experienced for long-distance airport travel?',
            answer: 'Yes, our drivers are well-trained and experienced in handling long-distance trips, including airport transfers, ensuring you reach Mumbai International Airport safely and on time.',
        },
        {
            id: 3,
            question: 'What types of vehicles are available for Pune to Mumbai International Airport travel?',
            answer: 'We offer a range of vehicles, including sedans, SUVs, and premium cars, all equipped for your comfort and convenience during the airport transfer.',
        },
        {
            id: 4,
            question: 'How do I pay for my Pune to Mumbai International Airport cab rental?',
            answer: 'We accept multiple payment options, including cash, credit/debit cards, and online payments via our app, for a convenient and secure transaction.',
        },
        {
            id: 5,
            question: 'Can I book a round trip from Pune to Mumbai International Airport?',
            answer: 'Yes, you can book a round-trip service. Simply provide your return details when booking, and we’ll take care of the rest.',
        },
        {
            id: 6,
            question: 'Are there any extra charges for waiting or detours?',
            answer: 'Any additional charges for waiting time or detours will be communicated to you upfront. We believe in complete transparency in our pricing, so there are no surprises.',
        },
        {
            id: 7,
            question: 'Can I hire a cab for sightseeing in Mumbai after airport drop-off?',
            answer: 'Yes, we offer customized sightseeing tours in Mumbai as part of your airport transfer. Explore Mumbai’s famous spots like the Gateway of India, Marine Drive, and more with a trusted driver.',
        },
        {
            id: 8,
            question: 'What is the luggage allowance for a Pune to Mumbai International Airport cab?',
            answer: 'Our vehicles are designed to accommodate standard luggage. If you have additional or special luggage requirements, please inform us during booking, and we will ensure the necessary arrangements are made.',
        },
        {
            id: 9,
            question: 'Is Vedant Travels available for corporate travel between Pune and Mumbai International Airport?',
            answer: 'Yes, we provide corporate travel solutions for airport transfers. Whether for business meetings, conferences, or group travel, we can offer customized packages tailored to your company\'s needs.',
        },
        {
            id: 10,
            question: 'Why should I choose Vedant Travels for Pune to Mumbai International Airport travel?',
            answer: 'Vedant Travels is known for its reliable, affordable, and comfortable airport transfer services. With professional drivers, well-maintained vehicles, and transparent pricing, we ensure a safe, smooth, and stress-free ride to Mumbai International Airport.',
        },
    ];
    
    const testimonials = [
        {
            name: "Mr. Sanjay Joshi",
            title: "Customer",
            quote: "I had an early morning flight from Pune to Mumbai International Airport, and Vedant Travels made sure I reached on time. The driver was friendly and the vehicle was clean and comfortable. Excellent service!",
            rating: 5,
        },
        {
            name: "Mrs. Priya Mehta",
            title: "Customer",
            quote: "We used Vedant Travels for our international airport transfer, and everything went perfectly. The driver was punctual, the ride was smooth, and we arrived at Mumbai International Airport with plenty of time. Highly recommend!",
            rating: 5,
        },
    ];
    
    











    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 8767459909",

        ],
        email: "booking@vedanttravels.in"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Pune to Mumbai Cab",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Pune to Mumbai Airport Cab",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Pune to Mumbai International Airport Cab",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Pune to Mumbai One Way Cab",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Pune Mumbai Car Hire",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "  Pune to Mumbai Taxi Fare ",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Pune to Mumbai Online Cab Booking",
        },

        {
            place: "/images/keyword/8.jpg",
            text: " Pimpri Chinchwad to Mumbai Cab",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Baner to Mumbai Cabs",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Hinjewadi to Mumbai Cab",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Pimple Saudagar to Mumbai Cab Service",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Wakad to Mumbai Cab",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "Hadapsar to Mumbai Cab",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Kalyani Nagar to Mumbai Taxi",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Koregaon Park to Mumbai Cab",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " Kothrud to Mumbai Cab",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Kharadi to Mumbai Cab",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Shivajinagar to Mumbai Cab",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Pune to Mumbai Ertiga Cab",
        },
        {
            place: "/images/keyword/20.jpg",
            text: " Pune to Mumbai Innova Crysta Cab",
        },
        
        {
            place: "/images/keyword/22.jpg",
            text: "Kondhwa to Mumbai Cab",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Viman Nagar to Mumbai Cabs",
        },
        {
            place: "/images/keyword/24.jpg",
            text: "Katraj to Mumbai Cab Service",
        },
        {
            place: "/images/keyword/25.jpg",
            text: " Pune Station to Mumbai Cabs Service",
        },
        {
            place: "/images/keyword/26.jpg",
            text: "Boat Club Road to Mumbai Cab ",
        },
        {
            place: "/images/keyword/27.jpg",
            text: " Vishrantwadi to Mumbai Cab",
        },
    ];


    const images = [
        { src: "/images/ourfleet/1.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/9.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/6.jpg", alt: "Image 1" },

    ];



    const jsonData = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pune to Mumbai International Airport Cab Service | Vedant Travels",
  "image": "https://www.vedanttravels.in/images/pune-to-mumbai-airport-cab.jpg",
  "description": "Book reliable and comfortable Pune to Mumbai International Airport cab services with Vedant Travels. Choose from a wide selection of vehicles like Innova Crysta, Ertiga, Swift Dzire, and more for a smooth journey to Chhatrapati Shivaji International Airport. Offering one-way and round-trip options, along with affordable pricing and quality services.",
  "brand": {
    "@type": "Brand",
    "name": "Vedant Travels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.8",
    "reviewCount": "5821",
    "bestRating": "5",
    "worstRating": "1"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "1499",
    "availability": "https://schema.org/InStock",
    "url": "https://www.vedanttravels.in/pune-to-mumbai-international-airport-cab",
    "validFrom": "2025-08-01"
  },
  "areaServed": {
    "@type": "Place",
    "name": [
      "Pune", 
      "Mumbai", 
      "Chhatrapati Shivaji International Airport", 
      "Andheri East", 
      "Bandra", 
      "Santacruz", 
      "Vile Parle"
    ]
  }
};



    return (
        <div>
           
<Helmet>
  <title>Pune to Mumbai International Airport Cab | Book Innova, Ertiga, Swift Dzire</title>
  <meta
    name="description"
    content="Book Pune to Mumbai International Airport cab with Vedant Travels. Choose Innova, Ertiga, Swift Dzire for one-way or return trips to Chhatrapati Shivaji Airport. On-time, affordable, and comfortable rides."
  />
  <meta
    name="keywords"
    content="Pune to Mumbai Airport Cab, Pune to Chhatrapati Shivaji International Airport Taxi, Pune to Mumbai Airport Drop Service, Pune to Mumbai Innova Crysta Cab, Pune to Mumbai Ertiga Cab, Pune to Mumbai Airport Swift Dzire, Airport Taxi Pune to Mumbai, Pune to Mumbai Airport One Way Cab, Vedant Travels Cab Service"
  />
  <meta name="robots" content="index, follow" />
  <link rel="canonical" href="https://www.vedanttravels.in/pune-to-mumbai-international-airport-cab" />
  <script type="application/ld+json">{JSON.stringify(jsonData)}</script>
</Helmet>




            <div
                className="site-breadcrumb"
                style={{ background: 'url(/img/breadcrumb/01.jpg)' }}
            >
                <div className="container">
                    <h2 className="breadcrumb-title">{cardData.keyword}</h2>

                </div>
            </div>

            <section id="about" className="jarallax text-light">
                <div className="center-y relative text-center">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 text-center">
                                <h1 className='text-white'>{cardData.keyword}</h1>
                            </div>
                            <div className="clearfix"></div>
                        </div>
                    </div>
                </div>
            </section>

            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/3.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#322E77', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Vedant Travels</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">


                                                <FAQKeyword faqData={faqData} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <TestimonialKeyword testimonials={testimonials} />

                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #006BB7',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#006BB7' }}>
                                            <h4 className=" lead fw-semibold whitt text-dark">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+918767459909" className="d-block  text-white">+91 8767459909</a>
                                                


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#006BB7' }}>
                                                <h4 className=" fw-semibold lead whitt text-dark">Email</h4>
                                                <a href="mailto:booking@vedanttravels.in" className=" text-white d-block">
                                                    booking@vedanttravels.in
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#006BB7' }}>
                                                <h4 className=" fw-semibold lead whitt text-dark">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Vedant Travels <br/>
                                                    S/R No. 66/1. Dhore Patil Farm,<br/>
                                                    Near New  Bharat Bakery,
                                                    New Sangvi <br/>Pimpri-Chinchwad,
                                                    Pune Maharashtra India- 411027.
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Punetomumbaiinternatinalairport;